import React from 'react'
import { DateTime } from 'luxon'
import AccessTimeIcon from 'components/material-symbol/icons/AccessTime'
import { DesktopTimePicker } from '@mui/x-date-pickers'
import {
  enterTimeViewRenderers,
  mergeEnterTimePickerSlotProps,
  ENTER_TIME_FIELD_FORMAT,
} from './enter-time-view'

const TimePickerIcon = props => <AccessTimeIcon {...props} />

const normalizePickerChangeValue = value => {
  if (value == null) return value
  if (DateTime.isDateTime(value)) return value
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return DateTime.fromJSDate(value)
  }
  return value
}

const PgaMobileTimePicker = ({
  id,
  label,
  value,
  onAccept,
  onChange,
  validationErrors,
  slotProps,
  slots,
  'data-cy': dataCy,
  ...pickerRest
}) => {
  return (
    <DesktopTimePicker
      minutesStep={5}
      closeOnSelect={false}
      {...pickerRest}
      id={id}
      label={label}
      value={value}
      onChange={() => {}}
      onAccept={val => {
        const normalized = normalizePickerChangeValue(val)
        onAccept?.(normalized)
        onChange?.(normalized)
      }}
      views={['hours']}
      format={pickerRest.format || ENTER_TIME_FIELD_FORMAT}
      viewRenderers={enterTimeViewRenderers}
      slots={{
        openPickerIcon: TimePickerIcon,
        ...slots,
      }}
      slotProps={mergeEnterTimePickerSlotProps({
        ...slotProps,
        textField: {
          error: Boolean(validationErrors),
          ...slotProps?.textField,
          inputProps: {
            'data-cy': dataCy,
            ...slotProps?.textField?.inputProps,
          },
        },
      })}
    />
  )
}

export default PgaMobileTimePicker
